































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import md5 from "js-md5";
const modifyModlue = namespace("mine");
@Component
export default class ModifyShop extends Vue {
	@modifyModlue.State("userMsg") userMsg!: any;
	pwdRegExp = /^.*(?=[^\u4e00-\u9fa5]{8,16})(?=[^\u4e00-\u9fa5]*\d)(?=[^\u4e00-\u9fa5]*[A-Z]{1,})(?=[^\u4e00-\u9fa5]*[a-z]{1,})(?=[^\u4e00-\u9fa5]*[!@#\$%\^&\*\?\(\),\.;:'"<>\{\}\[\]\\/\+-=\|_])[^\u4e00-\u9fa5]*$/;
	passwordOld: string = "";
	passwordNew: string = "";
	passwordTest: string = "";
	mounted() {}
	submitMsg() {
		if (!this.passwordOld || !this.passwordNew || !this.passwordTest) {
			this.$notify({ type: "warning", message: "请将密码输入完整！" });
			return;
		}
		if (
			!this.pwdRegExp.test(this.passwordNew) ||
			String(this.passwordNew).length > 16
		) {
			this.$notify({
				type: "warning",
				message: "密码必须为8到16位，并包含大小写字母和数字！",
			});
			return;
		}
		if (this.passwordNew != this.passwordTest) {
			this.$notify({
				type: "warning",
				message: "两次新密码输入不一致！",
			});
			return;
		}
		let params = {
			accountId: this.$global.uId,
			mobilePhone: this.$global.uPhone,
			password: md5(this.passwordNew),
			oldPassword: md5(this.passwordOld),
		};
		this.$store
			.dispatch("mine/resetPassword", params)
			.then(({ success, error }) => {
				if (success) {
					this.$notify({
						type: "success",
						message: "修改成功,请重新登陆",
					});
					const wx: any = (window as any).wx;
					(wx as any).miniProgram.reLaunch({
						url: "/pages/login/login?status=1",
					});
				} else {
					this.$notify({ type: "warning", message: error.msg });
				}
			});
	}
}
